var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPolicyCompliance = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 37 37",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.625 4.932H26.29a1.6 1.6 0 0 0-.346-.041H9.365c-.86 0-1.56.7-1.56 1.56v13.61a6.96 6.96 0 0 1 3.16-.755c1.672 0 3.21.59 4.414 1.572h6.946a1.08 1.08 0 0 1 0 2.16h-5.171a6.95 6.95 0 0 1 .806 3.502h4.365a1.08 1.08 0 0 1 0 2.16h-4.781a7.01 7.01 0 0 1-6.58 4.608 7 7 0 0 1-2.886-.623c.281.41.753.678 1.287.678h16.58c.86 0 1.56-.7 1.56-1.56V21.567h1.12c.64 0 1.161-.52 1.161-1.162V6.094c0-.642-.52-1.161-1.161-1.161m-6.3 12.445h-9.34a1.08 1.08 0 0 1 0-2.16h9.34a1.08 1.08 0 0 1 0 2.16m0-5.663h-9.34a1.08 1.08 0 0 1 0-2.16h9.34a1.08 1.08 0 0 1 0 2.16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.964 21.466a4.84 4.84 0 1 0 0 9.682 4.84 4.84 0 0 0 0-9.682m2.641 3.826L9.95 28.948a.65.65 0 0 1-.509.188.65.65 0 0 1-.396-.188l-.785-.784-1.1-1.1a.65.65 0 0 1 0-.916l.71-.71a.65.65 0 0 1 .916 0l.711.71 2.483-2.482a.647.647 0 0 1 .916 0l.71.71a.647.647 0 0 1 0 .916"
  })));
};
export default SvgPolicyCompliance;